module.exports = __webpack_public_path__ + "img/alive.8aad9161.png";